// extracted by mini-css-extract-plugin
export var base = "_3t-0";
export var updateBanner = "_3t-1";